import { render, staticRenderFns } from "./ListInquiry.vue?vue&type=template&id=489222fa&"
import script from "./ListInquiry.vue?vue&type=script&lang=js&"
export * from "./ListInquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports